import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AuthPageShell from "../components/AuthPageShell";
import SetupPassword from "../components/SetupPassword";
import {
  AUTH_FLOW_PURPOSE_KEY,
  AUTH_FLOW_PURPOSE_LOGIN,
  AUTH_FLOW_PURPOSE_PASSWORD_RESET,
} from "../../domain/constants/authFlowConstants";

const SetupPasswordPage = () => {
  const { t } = useTranslation("auth");
  const location = useLocation();
  const email = location.state?.email || "your@example.com";
  const purpose =
    location.state?.purpose ||
    sessionStorage.getItem(AUTH_FLOW_PURPOSE_KEY) ||
    AUTH_FLOW_PURPOSE_LOGIN;

  return (
    <AuthPageShell
      title={t("setupPassword.pageTitle")}
      subtitle={
        purpose === AUTH_FLOW_PURPOSE_PASSWORD_RESET
          ? t("setupPassword.subtitleReset")
          : t("setupPassword.subtitleCreate")
      }
    >
      <SetupPassword email={email} purpose={purpose} />
    </AuthPageShell>
  );
};

export default SetupPasswordPage;
